import { type ReactNode } from 'react';

import { Tag as ChakraTag } from '@chakra-ui/react';
import { DirectionsCar, Error, EventRepeat, ParkingPass, People, Schedule } from '@m/icons';

export type TagVariant = ChakraTag.RootProps['variant'] | 'success';

export interface TagProps extends Omit<ChakraTag.RootProps, 'variant'> {
  endElement?: ReactNode;
  onClose?: VoidFunction;
  startElement?: ReactNode;
  variant?: TagVariant;
}

export function Tag({ startElement, endElement, onClose, children, variant, ...rest }: TagProps) {
  return (
    <ChakraTag.Root variant={variant} {...rest}>
      {startElement && <ChakraTag.StartElement>{startElement}</ChakraTag.StartElement>}
      <ChakraTag.Label>{children}</ChakraTag.Label>
      {endElement && <ChakraTag.EndElement>{endElement}</ChakraTag.EndElement>}
      {onClose && (
        <ChakraTag.EndElement>
          <ChakraTag.CloseTrigger onClick={onClose} />
        </ChakraTag.EndElement>
      )}
    </ChakraTag.Root>
  );
}

export const commonTagsMap = {
  Visit: {
    label: 'Visit',
    startElement: <DirectionsCar />,
  },
  ParkingPass: {
    label: 'Parking Pass',
    startElement: <ParkingPass />,
  },
  Subscription: {
    label: 'Subscription',
    startElement: <EventRepeat />,
  },
  Reservation: {
    label: 'Reservation',
    startElement: <Schedule />,
  },
  Shared: {
    label: 'Shared',
    startElement: <People />,
  },
  PendingApproval: {
    label: 'Pending approval',
    startElement: <Error />,
  },
};

export const CommonTag = ({ type, ...rest }: { type: keyof typeof commonTagsMap } & TagProps) => {
  const { label, startElement } = commonTagsMap[type];
  return (
    <Tag startElement={startElement} {...rest}>
      {label}
    </Tag>
  );
};
